(function($, Drupal) {
  const retailWrapper = $(".layout--n-columns");
  const retailChildren = $(".layout--n-columns .layout__region").length;

  if (retailChildren > 8) {
    retailWrapper.addClass("slider-enabled").slick({
      slidesToShow: 8,
      slidesToScroll: 8,
      arrows: true,
      infinite: true,
      responsive: [
        {
          breakpoint: 767,
          settings: {
            rows: 2,
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }
})(jQuery, Drupal);
